export const createHonoraryMemberFormDropdownConfigs = [
    { dropdownName: "SubscriptionStatus", fieldId: "accountStatusId" },
    { dropdownName: "ReasonForINSOL", fieldId: "reasonforLeavingId" },
    { dropdownName: "MembershipTypeForHonorary", fieldId: "membershipTypeId" },
    { dropdownName: "MembershipTenure", fieldId: "membershipTensureId" },
    { dropdownName: "Country", fieldId: "placeofBirth" },
    { dropdownName: "Nationality", fieldId: "nationalityId" },
    { dropdownName: "Country", fieldId: "countryId" },
    { dropdownName: "HighestQualificationAttained", fieldId: "highestQualificationId" },
    { dropdownName: "Country", fieldId: "empCountryId" },
    { dropdownName: "MembershipType", fieldId: "membershipTypeName" },
    { dropdownName: "ApplicationStatus", fieldId: "applicationStatus" },
    { dropdownName: "JobRole", fieldId: "jobRoleId" },
    { dropdownName: 'Salutation Id', fieldId: 'salutationId' },
]
